// extracted by mini-css-extract-plugin
export default {"whack_mole_game_container":"whack-mole-game_whack_mole_game_container__SuIpC"};